import { createContext, useContext } from 'react';

const HtmlArtifactShelfContext = createContext(null);

export const HtmlArtifactShelfProvider = HtmlArtifactShelfContext.Provider;

export const useHtmlArtifactShelf = () => useContext(HtmlArtifactShelfContext);
